module.exports = __webpack_public_path__ + "img/letter-bob.f1775134.jpg";